<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#f7ac0a" type="ball-atom">
    <p style="font-size: 20px; color: #0072bc">Loading...</p>
</ngx-spinner>

<router-outlet></router-outlet>
